import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const ShokuinKbn = props => {
  return <Dropdown.Static kubunKey='shokuin_kbn' {...props} />
}
